import React from "react";

interface Props {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<Props> = ({ message, onRetry }) => (
  <div className="error-message">
    <p>{message}</p>
    {onRetry && (
      <button type="button" className="btn btn-secondary" onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);

export default ErrorMessage;
